// Detects browser contexts where sessionStorage does NOT reliably survive
// the user leaving and returning:
//  - a phone browser tab, where the OS reclaims backgrounded tabs far more
//    aggressively than desktop;
//  - an installed home-screen web app (PWA) — iOS in particular relaunches
//    a standalone PWA in a brand-new WKWebView process on every open.
//    sessionStorage never survives that relaunch even though localStorage
//    and IndexedDB do, which is exactly the "signed out every time I swipe
//    the app away" bug this exists to avoid.
// Both contexts should default Firebase Auth to a persistent (not
// session-only) persistence — see Login.js.

export function isStandalonePwa() {
  if (typeof window === 'undefined') return false;
  const mql = window.matchMedia && window.matchMedia('(display-mode: standalone)');
  return !!(mql && mql.matches) || window.navigator.standalone === true;
}

export function isMobileUserAgent() {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}

export function prefersPersistentLogin() {
  return isMobileUserAgent() || isStandalonePwa();
}
